module.exports = __webpack_public_path__ + "static/media/cases_web_keslon_02a.a80e9164.jpg";